import { Helmet } from "react-helmet-async";
import Screen from "../../Layouts/Screen/Screen";
import "./style.css"
import { CheckCircle, Filter, Search, UserMinus, Users, X } from "react-feather";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../../global-components/src";
import { useMessage } from "../../../global-components/src";
import { Post, Community } from "../../../types";
import ImgVerified from "../../../components/imgVerified/ImgVerified";
import Spinner, { LoadingThreeCircle } from "../../../global-components/src/components/spinner/spiner";
import PostList from "../../../components/Post/PostList";
import UserSearch from "./User/User";
import debounce from 'lodash/debounce';
import ItemList from "../../../components/ItemList/ItemList";
import { errorMessage } from "../../../utils/TextManagerTwo";
// import ModalPostComments from "../../Posts/PostLikes/ModalPostComments";
import ModalPostLikes from "../../Posts/PostLikes/ModalPostLikes";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import { getImagePathBucketPacoca } from "../../../global-components/src/utils/utils";
import { UserSearchLoadin } from "./User/UserSearchLoading";
import ModalCommentsBottom from "../../../components/Modals/comments/comments-bottom";
import ModalComments from "../../../components/Modals/comments/modal-comments";
import Cookies from "js-cookie";
import { User } from "../../../global-components/src/types";
import { t } from "i18next";
import UserRanking from "./User/user-ranking";

const RankingScreen = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [termo, setTermo] = useState(searchParams.get("termo") || "");
    const [termoLimpo, setTermoLimpo] = useState("");
    const [termoSearch, setTermoSearch] = useState(termo);
    const [typeSeach, setTypeSeach] = useState(searchParams.get("tipoFeed") || "user");
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState<User[] | null>(null);
    const [posts, setPosts] = useState<Post[]>([]);
    const [communities, setCommunities] = useState<Community[]>([]);
    const [filter, setFilters] = useState<any>({});
    const { token } = useAuth();
    const { setMessage } = useMessage();
    const navigate = useNavigate();
    const [loadingTermo, setLoadingTermo] = useState(false);
    const [dataNotFound, setDataNotFound] = useState(false); // Adicione um estado para a senha
    const [showModalLikes, setShowModalLikes] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const [idPostSelected, setIdPostSelected] = useState<number | null>(null);
    const [imgPath, setImgPath] = useState("");
    const [isDropdownVisible, setDropdownVisible] = useState(false);

    const showDropdown = (event: React.MouseEvent) => {
        event.preventDefault();
        setDropdownVisible(true);
    };
    const closeDropdown = () => {
        setDropdownVisible(false);
    };

    const changeTypeSearch = (type: string) => {
        setLoading(false)
        setUsers(null);

        // Se o tipo for diferente, atualizar o estado
        if (type !== typeSeach) {
            setTypeSeach(type);
        } else {
            // Se for o mesmo, apenas recarregar os dados
            handleSearch();
        }
    }

    useEffect(() => {
        setTermoLimpo(parseFiltro(termo).search.replace(/:([^\s]+)/g, ''));
    }, [termo])

    useEffect(() => {
        closeDropdown();
        const newParams = new URLSearchParams(searchParams);
        newParams.set("tipoFeed", typeSeach);
        setSearchParams(newParams, { replace: true });
    }, [typeSeach]);

    useEffect(() => {
        const handleModalClose = () => {
            setShowModalLikes(false)
            setShowModalComments(false)
            setIdPostSelected(null)
        };
    
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);

    const onCloseModals = () =>{
        setShowModalLikes(false)
        setShowModalComments(false)
        setIdPostSelected(null)
    }

    function parseFiltro(input: string) {
        const filtro: any = {
          search: '',
          user: '',
          dataInicial: '',
          dataFinal: '',
          group: '' // Novo campo para o grupo
        };
      
        const regex = /:(\w+)=([^\s]+)/g;
        let match;
        while ((match = regex.exec(input)) !== null) {
          const key = match[1];
          const value = match[2];
      
          if (key === 'usuario') filtro.user = value;
      
          if (key === 'data_inicial') {
            const dataMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (dataMatch) {
              const [_, dia, mes, ano] = dataMatch;
              filtro.dataInicial = `${ano}-${mes}-${dia}`; // Para o backend
            }
          }
      
          if (key === 'data_final') {
            const dataMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (dataMatch) {
              const [_, dia, mes, ano] = dataMatch;
              filtro.dataFinal = `${ano}-${mes}-${dia}`; // Para o backend
            }
          }
      
          if (key === 'comunidade') filtro.group = value; // Adiciona o filtro de grupo
        }
      
        // Remove comandos :chave=valor e :comando:
        filtro.search = input
          .replace(/:\w+=([^\s]+)/g, '')
          .replace(/:\w+:/g, '');
      
        return filtro;
      }
      
      
    const handleSearch = async () => {
        if (loading) return;
        setLoading(true)
        setUsers(null)
        setPosts([])
        setCommunities([])
        setDataNotFound(false);
        let text = encodeURIComponent(termoSearch);

        if (text.length <= 0 && typeSeach == "post") {
            setLoading(false)
            return;
        }
        
        if (text.length <= 0) {
            // text = "default-user";

            // // Carrega mensagens locais ANTES de buscar na API
            // const stored = localStorage.getItem(`default-user`);
            // if (stored) {
            //     const localData = JSON.parse(stored);
            //     setUsers(localData)
            // }
        }


        try {
            const url = `${PACOCA_API_URL}/ranking?page=0&search=${text}`;


            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            // if (text == "default-user" && data?.users?.length)
            //     localStorage.setItem("default-user", JSON.stringify(data?.users))

            if (data.users)
                setUsers(data.users)
            
            if (typeSeach == "user" && !data?.users?.length) {
                setDataNotFound(true)
            }
            
        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error");
            console.error("Erro ao pesquisar: ", messageError);
            console.error("Erro ao pesquisar: ", err);

        } finally {
            setLoading(false)
            setLoadingTermo(false)
        }

    };

    // const debouncedHandleSearch = useCallback(debounce(handleSearch, 500), [termo, typeSeach]);
    const debouncedHandleInput = useCallback(debounce(setTermoSearch, 500), [termoSearch]);
    useEffect(() => {
        handleSearch();
    }, [termoSearch, typeSeach]); // Um único useEffect para tratar tudo

    // useEffect(() => {
    //     if (termo.length) setLoadingTermo(true);
    // }, [termo]); // Um único useEffect para tratar tudo

    useEffect(() => {
        if (users?.length || communities?.length || posts?.length) {
            setLoadingTermo(false)
        }
    }, [users, communities, posts]);

    // useEffect(() => {
    //     setLoading(true)
    //     debouncedHandleSearch();
    // }, [termo, typeSeach]);

    // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const inputValue = event.target.value;
    //     setTermo(inputValue);
    //     debouncedHandleInput(inputValue)

    //     const newParams = new URLSearchParams(searchParams);
    //     newParams.set("termo", inputValue);
    //     setSearchParams(newParams, { replace: true });
    //     setUsers([]);
    //     setCommunities([]);
    // };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const input = event.target;
        const cursorPos = input.selectionStart || 0; // salva posição
        const inputValue = input.value;
        setTermo(inputValue);
        debouncedHandleInput(inputValue);

        const newParams = new URLSearchParams(searchParams);
        newParams.set("termo", inputValue);
        setSearchParams(newParams, { replace: true });
        setUsers([]);
        setCommunities([]);

        // Atualiza termoLimpo sem quebrar cursor
        setTermoLimpo(inputValue); 
        setTimeout(() => {
            input.setSelectionRange(cursorPos, cursorPos);
        }, 0);
    };
    
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            handleSearch()
        }
    };

    return (
        <>
            <Screen className="container-screen-search screen-search" title={t("generics.ranking")} >
                <Helmet>
                    <title>Paçoca - {t("generics.ranking")}</title>
                    <meta name="description" content={`Paçoca - Pesquise no paçoca!`} />
                    <meta name="keywords" content={`Paçoca, rede social brasileira, Pesquisa, pesquise, usuários}`} />
                    <meta name="author" content="Paçoca Inc." />
                    <meta property="og:title" content={`Paçoca - Pesquisa - Rede Social`} />
                    <meta property="og:description" content={`Paçoca - Pesquisa`} />
                    <meta property="og:image" content="/img/link-preview.png?v=1" />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="website" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={`Paçoca - Pesquisa - Rede Social`} />
                    <meta name="twitter:description" content={`Paçoca - Pesquise no paçoca`} />
                    <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>
                <div>
                    <div className="d-flex container-search container-search-padding">
                        <input
                            id="input-search-screen"
                            className="form-control input-search input-search-screen"
                            type="text"
                            name="search"
                            placeholder={t("generics.search")}
                            aria-label="Search"
                            value={termoLimpo}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            required
                        />
                        <button onClick={(e) => {handleSearch} } className="btn-search btn-search-screen input-search-screen-icon-menu-dark btn" type="button" title="Buscar">
                            <Search color="#d3d3d3" />
                        </button>
                    </div>
                  

                    {dataNotFound ? (
                        <div className="user-select-none row row-empty-comment">
                            <span className="span-empty">
                                <UserMinus className="icon-empty" />
                                <h3 className="w-100 text-center">{t("empty.users")}</h3>
                            </span>
                        </div>
                    ) : null}

                    {users?.map((user, index) => (
                        <UserRanking clasNameSearch="" clasImgAccount="img-list-chat" key={index} user={user} />
                    ))}

                    <UserSearchLoadin loading={loading || loadingTermo} />
                </div>
            </Screen>
        </>
    );
};

export default RankingScreen;